import React from "react";
import Forms from "./Forms";
import { z } from "zod";

// TODO: runtime validation should happen inside `/contatti.tsx`
//       components should express requirements using typescript type.
//       this should be done to avoid unnecessary runtime cost
const ContactPage = z.array(
  z.object({
    _id: z.string(),
    slug: z.string(),
    form: z.object({
      heading: z.string(),
      shortText: z.string(),
      buttonText: z.string(),
      templateId: z.string(),
      sendTo: z.string(),
      validErrorText: z.any(),
      fields: z.array(z.record(z.string(), z.any())),
    }),
  })
);

type Props = {
  pages: z.infer<typeof ContactPage>;
};

const Contacts: React.FC<Props> = (props) => {
  const { pages } = props;

  // TODO: rebuild the UI using ./Form and ./Forms
  return <Forms formList={pages} />;

  //<pre>{JSON.stringify(pages, null, 3)}</pre>;
};

export default Contacts;
